// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { getBallotStyleSlates, getBallotStyleSlatesCoverage, } from "@sequentech/ui-core";
import { ESlateOfficesLayout, getSlateOffices } from "./SlateCoverage";
export { getSlateName } from "@sequentech/ui-core";
var resolveSlate = function (slate, contests) { return ({
    id: slate.id,
    name: slate.name,
    contests: contests.flatMap(function (contest) {
        var _a;
        var memberIds = (_a = slate.members[contest.id]) !== null && _a !== void 0 ? _a : [];
        var candidates = memberIds.flatMap(function (id) { var _a; return (_a = contest.candidates.find(function (candidate) { return candidate.id === id; })) !== null && _a !== void 0 ? _a : []; });
        return candidates.length > 0 ? [{ contest: contest, candidates: candidates }] : [];
    }),
}); };
var resolveCoveredSlate = function (slate, contests, coverage) { return ({
    id: slate.id,
    name: slate.name,
    contests: getSlateOffices(coverage, contests, ESlateOfficesLayout.STACKED),
    coverage: coverage,
    offices: getSlateOffices(coverage, contests, ESlateOfficesLayout.ALIGNED),
}); };
/**
 * The slates of a ballot. With `coverage`, only the slates it lists are kept,
 * with the candidates it counts.
 */
export var resolveSlates = function (config, contests, coverage) {
    var slates = coverage
        ? coverage.flatMap(function (slateCoverage) {
            var slate = config.slates.find(function (entry) { return entry.id === slateCoverage.slate_id; });
            return slate ? [resolveCoveredSlate(slate, contests, slateCoverage)] : [];
        })
        : config.slates
            .map(function (slate) { return resolveSlate(slate, contests); })
            .filter(function (slate) { return slate.contests.length > 0; });
    var covered = new Set(slates.flatMap(function (slate) { return slate.contests.map(function (_a) {
        var contest = _a.contest;
        return contest.id;
    }); }));
    return {
        mobileCandidateLists: config.mobile_candidate_lists,
        slates: slates,
        contests: contests.filter(function (contest) { return covered.has(contest.id); }),
    };
};
/**
 * The slates of a ballot, or null when its election has none. Throws the
 * problems of an invalid configuration, as `getBallotStyleSlates` does.
 */
export var resolveBallotStyleSlates = function (ballotEml) {
    var config = getBallotStyleSlates(ballotEml);
    return config
        ? resolveSlates(config, ballotEml.contests, getBallotStyleSlatesCoverage(ballotEml))
        : null;
};
var isSlateProblem = function (value) {
    return typeof value === "object" &&
        value !== null &&
        typeof value.message === "string";
};
/** Why a ballot's slate configuration is refused, or undefined when it is sound. */
export var getSlateConfigurationProblem = function (ballotEml) {
    try {
        getBallotStyleSlates(ballotEml);
        return undefined;
    }
    catch (error) {
        var first = (Array.isArray(error) ? error : [error])[0];
        return isSlateProblem(first) ? first.message : String(first);
    }
};
